var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('HeaderTitle'),_c('div',{staticClass:"pt-2"},[_c('router-link',{staticClass:"btn btn-primary w-100 mb-2",attrs:{"to":"/accidents/create"}},[_vm._v("Добавить ДТП")])],1),_c('AccidentListView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }